module.exports = __webpack_public_path__ + "img/weChatAuthorization.44242927.png";